import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { DashboardTinyUpseller } from '@marvelapp/askhub-upsells';
import { useConfig, useCurrentUser, useLogout, } from '@marvelapp/ballpark-application';
import { Avatar, Dropdown, Heading, Icon, SquareButton, } from '@marvelapp/ballpark-components';
import { DOTS_ICON } from '@marvelapp/ballpark-theme';
import { getRoleDisplayLabel } from '@marvelapp/core';
import styled from '@marvelapp/styled';
import { Box, Flex, Text } from '@marvelapp/ui';
import { Link } from '@marvelapp/ui-internal';
import { getUserBlockLinks } from './links';
export default function UserBlock() {
    const user = useCurrentUser();
    const { image, username, company, role } = user;
    const [isPopoverActive, setIsPopoverActive] = useState(false);
    return (_jsxs(Container, { children: [_jsx(Upsell, { children: _jsx(DashboardTinyUpseller, {}) }), _jsxs(Footer, { children: [_jsx(Avatar, { size: "xs", src: image, username: username }), _jsx(Heading, { as: "p", flex: 1, pl: "xs", size: "s", truncated: true, children: username }), _jsxs(Dropdown.Root, { onOpenChange: () => setIsPopoverActive(!isPopoverActive), children: [_jsx(SquareButton, { as: Dropdown.Trigger, isActive: isPopoverActive, translateOnHover: false, "data-testid": "my-settings", children: _jsx(Icon, { paths: DOTS_ICON }) }), _jsx(Dropdown.Content, { position: "top", children: _jsx(DropdownContent, { company: company, role: role }) })] })] })] }));
}
function DropdownContent({ role, company }) {
    const logout = useLogout();
    const config = useConfig();
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const links = getUserBlockLinks();
    return (_jsxs(Box, { width: 210, children: [company && (_jsx(Flex, { alignItems: "center", borderBottom: "1px solid", borderColor: "smoke", padding: 3, children: _jsxs(Box, { children: [_jsx(Heading, { as: "h3", fontSize: 14, fontWeight: 500, paddingTop: "1px", children: company.name }), _jsx(Text, { fontSize: 2, marginTop: "2px", children: getRoleDisplayLabel(role) })] }) })), _jsx(Box, { py: 15, children: links.map((link) => (_jsx(Dropdown.Item, { "data-testid": link.name.replace(/[\s]+/g, '-').toLowerCase(), as: Link, target: link.target, to: link.to, children: link.name }, link.name))) }), _jsx(Box, { borderTop: "1px solid", borderColor: "smoke", py: 10, children: _jsx(Dropdown.Item, { forceExternal: true, 
                    // we need to prevent accidental double taps, to avoid a backend error
                    isDisabled: isLoggingOut, onClick: () => {
                        setIsLoggingOut(true);
                        logout().finally(() => {
                            window.location.href = `${config.ballpark.marketingSite}`;
                        });
                    }, target: "_self", children: "Sign out" }) })] }));
}
const Container = styled(Box) `
  bottom: 0;
  width: 100%;
`;
const Upsell = styled(Box).attrs({
    paddingBottom: 2,
    px: 3,
}) `
  flex-grow: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
`;
const Footer = styled(Box).attrs({
    py: 's',
    pl: 's',
    pr: 'xs',
}) `
  width: 100%;
  display: flex;
  align-items: center;
`;
